<template>
  <div class="modal .collapse.show" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="delete-modal-header">
          <h3 class="modal-title">Exclusão Biométrica</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="delete-body">
          <div class="body-title">Iniciar Análise de Exclusão?</div>

          <div class="delete-row">
            <div class="form-group">
              <label class="delete-label">Motivo</label>
              <select class="delete-field" v-model="motivo" required>
                <option v-if="listMotivos" v-for="mot in listMotivos" :key="mot.value" :value="mot.value">
                  {{ mot.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="delete-row">
            <div class="form-group">
              <label class="delete-label">Observação</label>
              <textarea v-model="obs" class="delete-field" rows="6" cols="85" id="descriptionDelete"
                        required></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" v-on:click="sendToAnalisys" data-dismiss="modal" class="btn btn-danger">
            Salvar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'

export default {
  name: 'DeleteModal',
  data: function () {
    return {
      obs: '',
      motivo: ''
    }
  },
  props: {
    listMotivos: [],
    cpf: ''
  },
  methods: {
    sendToAnalisys: function (event) {
      event.preventDefault()
      if ((this.motivo !== undefined || this.motivo !== '') && (this.obs !== undefined && this.obs !== '')) {
        const userCreation = window.localStorage.getItem('usercod')
        const cpf = this.cpf
        const descriptionCreation = this.obs
        const statusCreation = this.motivo
        interceptor.request('post', 'api/v1/delete/sendanalisys', {
          userCreation,
          cpf,
          descriptionCreation,
          statusCreation
        })
          .then(response => {
            $('#divAlert').attr('class', 'alert alert-success')
              .append('<p style="font-weight: bold;">Biometria enviada para Análise de Exclusão com sucesso.</p>')
              .show()
          })
          .catch(function (error) {
            console.log(error.response.status)
            $('#divAlert').attr('class', 'alert alert-danger')
              .append('<p style="font-weight: bold;">Não foi possível efetuar esta ação. Serviço indisponível.</p>')
              .show()
          })
      } else {
        $('#divAlert').attr('class', 'alert alert-warning')
          .append('<p style="font-weight: bold;">Para iniciar a análise o motivo e a descrição devem ser preenchidos.</p>')
          .show()
      }
    }
  }
}
</script>

<style scoped>
.delete-modal-header {
  background-color: #211858;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.delete-modal-header > h3 {
  font-weight: 600;
  font-size: 1.2rem;
  color: var(--color-e9ecef);
}

.delete-modal-header > button {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(141deg) brightness(103%) contrast(103%);
}

.delete-body {
  display: flex;
  flex-direction: column;
  margin: 2rem;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
}

.body-title {
  font-weight: 520;
  font-size: 2rem;
  letter-spacing: 1px;
  text-transform: capitalize;
}

.delete-row {
  display: block;
  width: 100%;
}

.delete-field {
  width: 98%;
}

.delete-label {
  display: block;
  font-size: 1.2rem;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// DeleteModal.vue?7abb72b7